import React from 'react';

const BoardOfDirectorsPage = props => {
    const bod = [
        'Thomas Alston',
        'Joey Burrough',
        'Matt Glover',
        'Linda Harris',
        'Randy Holmes',
        'Wayne Kish',
        'Kenneth Marks',
        'Dave Riley',
        'Peter Rochelle',
        'Madi Smith',
        'Spencer Tilley',
        'Scott Ziegler'
    ];

    return (
        <div className="staticPage">
            <h1>YCFC Board of Directors</h1>
            <ul className="bodList">
                {bod.map(member => <p key={member}>{member}</p>)}
            </ul>
        </div>
    );
};

export default BoardOfDirectorsPage;



// WEBPACK FOOTER //
// ./src/pages/board-of-directors.js